<template>
    <div>
        <div  class="" style="background: #FAFAFA; padding-bottom: 30px;">
            <div class="container">
                <div class="d-flex justify-content-between align-items-baseline">
                    <h3 class="bills-text"><span class="fa fa-chevron-left" @click="goback()"></span>Airtime</h3>
                    <h5 class="history-text" @click="routeTo('/dashboard/bills-history')">History</h5>
                </div>

                <div class="network-selection-holder">
                    <div>
                        <label for="">Choose Network</label>
                        <div class="network-body">
                            <div class="network-item" @click="network = 'MTN'" :class="network === 'MTN' ? 'mtn-b' : ''">
                                <img src="../../assets/billpayment/MTN.svg" alt="mtn">
                                <h6>MTN</h6>
                            </div>
                            <div class="network-item" @click="network = 'AIRTEL'" :class="network === 'AIRTEL' ? 'airtel-b' : ''">
                                <img src="../../assets/billpayment/AIRTEL.svg" alt="airtel">
                                <h6>Airtel</h6>
                            </div>
                            <div class="network-item" @click="network = 'GLO'" :class="network === 'GLO' ? 'glo-b' : ''">
                                <img src="../../assets/billpayment/GLO.svg" alt="Glo">
                                <h6>GLO</h6>
                            </div>
                            <div class="network-item" @click="network = '9MOBILE'" :class="network === '9MOBILE' ? 'ninemoble-b' : ''">
                                <img src="../../assets/billpayment/NINEMOBILE.svg" alt="ninemobile">
                                <h6>9Mobile</h6>
                            </div>
                        </div>
                    </div>
                    <hr>
                    <div class="form-group">
                        <div class="beneficiries">
                            <label for="phonenumber">Phone number</label>
                            <span @click="choseFromContact()">Choose from contact <i class="fa fa-cheveron-right"></i></span>
                        </div>
                        <input v-model="phoneNumber" minlength="11" maxlength="11" pattern="[0-9]{11}" type="tel" id="phonenumber" class="form-control" required placeholder="Enter 11 digit number">
                        <!-- <div class="ben-holder">
                            <input type="checkbox" id="savebeneficiaris" class="form-control" true-value="yes"
                                false-value="no" v-model="savebeneficiary">
                            <label for="savebeneficiaris">Save Beneficiary</label>
                        </div> -->
                    </div>
                </div>

                <div class="payment-method-holder">
                    <!-- <label for="paymentmethod">Top Up</label> -->
                    <div class="selected-amount">
                        <label for="choose-amount">Top Up</label>
                        <div class="amount-box" id="choose-amount">
                            <div class="amount-item" @click="selectedAmountValue(1000)">₦1,000</div>
                            <div class="amount-item" @click="selectedAmountValue(2000)">₦2,000</div>
                            <div class="amount-item" @click="selectedAmountValue(5000)">₦5,000</div>
                            <div class="amount-item" @click="selectedAmountValue(10000)">₦10,000</div>
                            <div class="amount-item" @click="selectedAmountValue(15000)">₦15,000</div>
                            <div class="amount-item" @click="selectedAmountValue(20000)">₦20,000</div>
                            <div class="amount-item" @click="selectedAmountValue(30000)">₦30,000</div>
                            <div class="amount-item" @click="selectedAmountValue(40000)">₦40,000</div>
                            <div class="amount-item" @click="selectedAmountValue(50000)">₦50,000</div>
                        </div>
                    </div>
                    <div class="form-group">
                        <label for="amount">Amount</label>
                        <input type="text" id="amount" class="form-control" placeholder="Amount" v-model="formattedAmount">
                    </div>
                    <div class="provider-holder">
                        <div class="custom-dropdown">
                            <label for="type">Type</label>
                            <div class="selected-option" id="provider" @click.stop="togglePanelProvider">
                                <span id="current-name">{{ optionData == '' ? 'Select type': optionData }}</span>
                                <!-- <span><i class="fa fa-chevron-right"></i></span> -->
                            </div>

                            <!-- The hidden panel of countries -->
                            <ul class="options-panel" id="provider" v-if="providerPanel">
                                <li @click="selectProvider('PREPAID')">
                                    PREPAID
                                </li>
                                <li @click="selectProvider('POSTPAID')">
                                    POSTPAID
                                </li>        
                            </ul>
                        </div>
                    </div>
                </div>

                

                <div class="payment-method-holder">
                    <label for="paymentmethod">Select Payment Method</label>
                    <div class="paymentOfPayment" id="paymentmethod">
                        <div class="" style="position: relative;">
                            <!-- <div class="payment-item col-md-6" @click="paymentType = 'paystack'" :class="[paymentType == 'paystack' ? 'active-payment' : '']">
                                <img src="../../assets/billpayment/paystack.svg" alt="paystack">
                                <h6>Pay with Paystack</h6>
                            </div> -->
                            <div class="payment-item col-md-6" @click="paymentType = 'safe'" :class="[paymentType == 'safe' ? 'active-payment' : '']">
                                <img src="../../assets/billpayment/safe-logo.svg" alt="safe">
                                <div>
                                    <h6>Pay with SAFE</h6>
                                    <p>Available balance: <span>₦{{Number(safeDetails.balance || 0).toLocaleString()}}</span></p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="submitPayment">
                        <button class="btn" @click="openConfirmation()">Pay Now</button>
                    </div>
                    <confirmPayment @call-parent="buyAirtime" ref="confirmModalBill" />
                    <succesfulPayment :billdata="billObject" @call-parent="buyAirtime" ref="successfulPaymentMade"/>
                </div>
                <!-- <confirmPayment :billdata="billObject" />
                <succesfulPayment :billdata="billObject"  /> -->
            </div>
        </div>
        <div v-if="loading">
            <PageLoader></PageLoader>
        </div>
    </div>
</template>

<script>
import confirmPayment from './ConfirmPayment.vue';
import succesfulPayment from './SuccessfulPayment.vue';
import { Service } from "../../store/service";
import PageLoader from "../../components/PageLoader.vue";
const Api = new Service();
import $ from "jquery";
export default {
    name: "Airtime",
    components: {
        confirmPayment,
        succesfulPayment,
        PageLoader
    },
    data() {
        return {
            loading: false,
            // imgScr: "",
            optionData: "",
            providerPanel: false,
            paymentType: "safe",
            billObject: {},
            savebeneficiary: 'no',
            amount: 0,
            phoneNumber: "",
            network: "",
            vendor_type: "",
            coverPoint: 0,
            user: "",
            rewardObject: "",
            safeDetails: "",
        }
    },
    computed: {
        formattedAmount: {
            get() {
                if (!this.amount) return '';
                return this.amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
            },
            set(value) {
                // remove commas before storing
                this.amount = value.replace(/,/g, '');
            }
        }
    },
    // set-transaction-pin
    // update-transaction-pin
    mounted() {
        // Add listener when component is mounted
        document.addEventListener('click', this.close);
        document.addEventListener('click', this.close2);
        this.user = localStorage.getItem("shelta-user");
        this.fetchReward();
    },
    beforeDestroy() {
        // Crucial: remove listener to prevent memory leaks
        document.removeEventListener('click', this.close);
        document.removeEventListener('click', this.close2);
    },
    methods: {
        routeTo(route) {
            this.$router.push({
            path: route
            })
            .catch(() => {});
        },
        goback() {
            window.history.length > 1 ? this.$router.back() : this.$router.push('/dashboard/bills-payment')
        },
        choseFromContact() {
            this.phoneNumber = JSON.parse(this.user).phone;
        },
        async buyAirtime(messageFromParent) {
            // console.log("Processing bill payment")
            $("#confirmPaymentBill")
            .removeClass("fade")
            .modal("hide");
            // console.log("Message form parent", messageFromParent)
            this.loading = true
            const payload = {
                mode_of_payment: this.billObject.paymentMethod,
                telco: this.network,
                vend_type: this.optionData,
                phone: this.phoneNumber,
                amount: this.amount,
                cova_points: messageFromParent.sentData.coverPoint,
            }
            try {
                await Api.postRequest(`pay-for-airtime`, JSON.stringify(payload))
                .then(res => {
                // this.$root.$refs.openSuccess.openSuccessModal();
                if(res.data.requery == 'yes') {
                    this.loading = true;
                    return this.requery(res.data.requery_id)
                }
                this.loading = false;
                if (res.data.error) {
                    return this.$store.commit("setApiFailed", res.data.error);
                }
                if (res.data.success) {
                    this.loading = false;
                    this.billsHook();
                    this.$store.commit("setApiSuccess", "success");
                    res.data.data.payment_type = this.paymentType;
                    res.data.data.transaction_type = 'Airtime';
                    res.data.data.purchasePhone = this.phoneNumber;
                    res.data.data.reward = this.rewardObject;
                    this.sendingSuccessfulData = res.data;
                    this.$root.$refs.openSuccess.openSuccessModal();
                    this.$refs.successfulPaymentMade.setDataSuccess(res.data); 
                }
                })
                .catch(err => {
                    console.log("ERROR", err)
                    this.loading = false;
                });
            } finally {
            // console.log("Closed connection");
            }
        },
        async requery(requeryId) {
            this.loading = true
            try {
                await Api.getRequest(`requery-bill/${requeryId}`)
                .then(res => {
                this.loading = false;
                // this.$root.$refs.openSuccess.openSuccessModal();
                if (res.data.error) {
                    return this.$store.commit("setApiFailed", res.data.error);
                }
                if (res.data.success) {
                    this.loading = false;
                    this.billsHook();
                    this.$store.commit("setApiSuccess", "success");
                    res.data.data.payment_type = this.paymentType;
                    res.data.data.transaction_type = 'Airtime';
                    res.data.data.purchasePhone = this.phoneNumber;
                    res.data.data.reward = this.rewardObject;
                    this.sendingSuccessfulData = res.data;
                    this.$root.$refs.openSuccess.openSuccessModal();
                    this.$refs.successfulPaymentMade.setDataSuccess(res.data); 
                }
                })
                .catch(err => {
                    // this.loader2 = false;
                    this.loading = false;
                });
            } finally {
            // console.log("Closed connection");
            }
        },
        billsHook() {
            Api.getRequest(`bills-hook`).then((res) => {
                // console.log("Bill hook", res);
            }).catch(err => {
                this.loading = false;
            });
        },
        selectProvider(title, srcImg) {
            this.optionData = title;
        },
        togglePanelProvider() {
            this.providerPanel = !this.providerPanel;
        },
        close(e) {
            // Check if the click was outside this component's root element
            if (this.$el.contains(e.target)) {
                this.providerPanel = false;
            }
        },
        openConfirmation() {
            if (this.network == '') {
                return this.$store.commit("setApiFailed", "Select network");
            }
            if (this.phoneNumber == '') {
                return this.$store.commit("setApiFailed", "Enter phone number");
            }
            if (this.phoneNumber.length < 11) {
                return this.$store.commit("setApiFailed", "Phone number must have 11 characters");
            }
            if (this.amount == '') {
                return this.$store.commit("setApiFailed", "Enter or select amount");
            }
            if (this.optionData == '') {
                return this.$store.commit("setApiFailed", "Select bill type");
            }
            else {
                // console.log("Open modal confirmation")
                this.billObject.amount = Number(this.amount);
                this.billObject.paymentType = "Airtime"
                this.billObject.paymentMethod = "safe";
                this.billObject.network = this.network;
                this.billObject.phone = this.phoneNumber;
                this.billObject.cover_points = this.coverPoints;
                this.billObject.vend_type = this.optionData;
                this.billObject.reward = this.rewardObject;
                this.$refs.confirmModalBill.setDataSuccess(this.billObject); 
                this.$root.$refs.openConfirm.openConfirmationModal();
            }
            // if (this.billObject != null) {
                
            // }
            // this.$emit('date-clicked', billObject);
        },
        async fetchReward() {
            try {
                await Api.getRequest(`shelta-rewards`).then(res => {
                if (res.data.error) {
                    return this.$store.commit("setApiFailed", res.data.error);
                }
                if (res.data.success) {
                   this.rewardObject = res.data;
                   this.fetchSafeData();
                }
                })
                .catch(err => {
                    console.log("ERROR", err)
                    // this.loader2 = false;
                    this.loading = false;
                });
            } finally {
            // console.log("Closed connection");
            }
        },
        async fetchSafeData() {
            try {
                await Api.getRequest(`fetchsafedata`)
                .then(res => {
                    if (res.data.success) {
                        // console.log("Safe data", res);
                        this.safeDetails = res.data;   
                    }
                    if (res.data.error) {
                    this.$store.commit("setApiFailed", "Can not read safe data");
                    }
                })
                .catch(err => {
                    console.log(err);
                });
            } finally {
                // console.log("Closed connection");
            }
        }, 
        selectedAmountValue(selectedmount) {
            // if(selectedmount != null || selectedmount != 0) {
            //     this.amount = toLocaleString(selectedmount);
            // }
            this.amount = selectedmount;
        },
    },
}
    
</script>


<style scoped lang="scss">
.bills-text {
    font-family: Lato;
    font-weight: 600;
    font-size: 20px;
    line-height: 60px;
    text-align: left;
    color: #1A1A1A;
    margin-top: 40px;
    span {
        font-size: 18px;
        margin-right: 20px;
        cursor: pointer;
    }
}

.history-text {
    font-family: Lato;
    font-weight: 400;
    font-size: 16px;
    line-height: 60px;
    color: #4688F4;
    cursor: pointer;
    margin-top: 40px;

}

.network-body {
    display: flex;
    justify-content: center;
    gap: 20px;
    overflow: scroll;
    flex-wrap: nowrap;
}
.network-item {
    background: #F8F9FA;
    border: 1px solid #F8F9FA;
    padding: 8px 12px;
    border-radius: 8px;
    min-width: 120px;
    min-height: 120px;
    cursor: pointer;
    img {
        margin-top: 25px;
        margin-bottom: 5px;
    }
    h6 {
        font-family: Lato;
        font-weight: 400;
        font-size: 14px;
        // line-height: 100%;
        color: #555555;
        text-align: center;

    }
}

.mtn-b {
    border: 1px solid #FFB100 !important;
    p {
        color: #FFB100 !important;
        background: #FFB1001A !important;
    }
}
.airtel-b {
    border: 1px solid #ea0000 !important;
    p {
        color: #ea0000 !important;
        background: #fbe3e3 !important;
    }
}
.glo-b {
    border: 1px solid #11a507 !important;
    p {
        color: #11a507 !important;
        background: #e1fbdf !important;
    }
}
.ninemoble-b {
    border: 1px solid #D6E806 !important;
    p {
        color: #D6E806 !important;
        background: #747a30 !important;
    }
}

.network-selection-holder {
    background: #ffffff;
    padding: 24px 16px 16px 16px;
    border-radius: 12px;
    margin-top: 30px;
}

label {
    font-family: Lato;
    font-weight: 500;
    font-size: 16px;
    color: #555555;
    text-align: left;
    display: flex;
}

select {
    box-shadow: none !important;
    outline: 0 !important;
    height: 48px;
    border: none;
    padding-left: 0;
    font-family: Lato;
    font-weight: 500;
    color: #555555;
    font-size: 16px;
    

}
.provider-holder {
    background: #ffffff;
    padding: 24px 0px 16px 0px;
    border-radius: 12px;
}


.custom-dropdown {
  position: relative;
//   width: 250px;
}

.selected-option {
  padding: 10px;
  border: 1px solid #E6E9EC;;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 10px;
  background: #fff;
  border-radius: 4px;
  font-family: Lato;
  font-weight: 500;
  font-size: 14px;
}

.options-panel {
//   display: none; /* Hidden by default */
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  border: 1px solid #ccc;
  background: #fff;
  list-style: none;
  padding: 0;
  margin: 0;
  max-height: 200px;
  overflow-y: auto;
  z-index: 1000;

  font-family: Lato;
  font-weight: 500;
  font-size: 16px;

}

.options-panel li {
  padding: 10px;
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
}

.options-panel li:hover {
  background-color: #f0f0f0;
}

/* Class to show the panel */
.show {
  display: block;
}

input {
    height: 48px;
    border-radius: 4px;
//   border: 1px solid #e7e7e7;
    border: 1px solid #ccc;
    background: #F8F9FA !important;
    border: none;
//   color: #aaadba;
    font-family: Lato;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%;
    outline: 0 !important;
    box-shadow: none !important;
}
.beneficiries {
    display: flex;
    justify-content: space-between;
    margin-top: 30px;
    span {
        color: #555555;
        font-family: Lato;
        font-weight: 400;
        font-size: 14px;
        cursor: pointer;
    }
}
.ben-holder {
    display: flex;
    align-items: center;
    margin-top: 10px;
    label {
        margin-bottom: 0;
        font-family: Lato;
        font-weight: 400;
        font-size: 14px;
        color: #9CA3AF;

    }
}
#savebeneficiaris {
    height: 17px;
    width: 17px;
    margin-right: 10px;
    cursor: pointer;
}
.deals-holder:hover {
    border: 1px solid #e1e1e1;
}
.activeDeals {
    border: 1px solid #FFB100 !important;
}
.deals-holder {
    display: flex;
    justify-content: space-between;
    border-radius: 8px;
    padding: 15px;
    background: #F8F9FA;
    border: 1px solid #F8F9FA;
    margin-bottom: 15px;
    gap: 20px;
    cursor: pointer;
    h6, h5 {
        font-family: Lato;
        font-weight: 600;
        font-size: 16px;
        line-height: 30px;
        color: #555555;
        text-align: left;
    }
    h6 {
        color: #555555;
    }
    h5 {
        color: #1A1A1A;
    }
    p {
        margin-bottom: 0;
        background: #FFB1001A;
        font-family: Lato;
        font-weight: 500;
        color: #FFB100;
        font-size: 14px;
        padding: 4px 8px;
        border-radius: 50px;
        white-space: nowrap;
    }
}

.amount-holder, .payment-method-holder {
    background: #ffffff;
    padding: 24px 16px 16px 16px;
    border-radius: 12px;
    margin-top: 30px;
}

.amount-box {
    display: flex;
    flex-wrap: wrap;
    // justify-content: space-between;
    
}
.amount-item {
    background: #F8F9FA;
    padding: 12px 8px;
    border-radius: 8px;
    font-family: Lato;
    font-weight: 400;
    font-size: 14px;
    text-align: center;
    margin-bottom: 20px;
    cursor: pointer;
}
.amount-item:hover {
    background: #e5e5e6;
}

.amount-item:not(:last-child) {
    margin-right: 15px;
}

.paymentOfPayment {
    // display: flex;
    margin-top: 30px;
}
.payment-item {
    display: flex;
    align-items: center;
    border: 1px solid #E6E9EC;
    padding: 16px;
    gap: 8px;
    border-radius: 6px;
    height: 75px;
    margin-bottom: 10px;
    cursor: pointer;
    // width: 50%;
    h6 {
        font-family: Lato;
        font-weight: 400;
        font-size: 17px;
        // line-height: 100%;
       color: #1A1A1A;
        text-align: left;
        margin-bottom: 0;
    }
    p {
        font-family: Lato;
        font-weight: 400;
        font-size: 15px;
        // line-height: 100%;
        color: #555555;
        text-align: left;
        margin-bottom: 0;
        span {
            color: #4688F4;
        }
    }
}
.payment-item:hover {
    border: 1px solid #0033EA;
}
.active-payment {
    border: 1px solid #0033EA;
}

.submitPayment {
    margin-top: 40px;
    button {
        background: #0033EA;
        color: #ffffff;
        font-family: Lato;
        font-weight: 500;
        font-size: 14px;
        width: 100%;
        height: 48px;
        outline: 0;
        box-shadow: none;
    }
}
/* For Chrome, Safari, Edge, and Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0; /* Removes a small margin in older Chrome versions */
}

/* For Firefox */
input[type=number] {
    -moz-appearance: textfield;
}

/* Optional: Combine into a class for specific inputs */
.no-spinners::-webkit-outer-spin-button,
.no-spinners::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

.no-spinners {
    -moz-appearance: textfield;
    appearance: textfield; /* Standard property (works in newer browsers) */
}
@media only screen and (max-width: 599px) {
    .network-item { 
        min-width: 90px;
        min-height: 90px;
        img {
            margin-top: 10px;
        }
    }
    .network-body {
        justify-content: space-between;
    }
}
</style>